import React, { Component } from "react";
import { connect } from "react-redux";
import RevenueSummary from "./dashboard/RevenueSummary";
import RevenueChart from "./dashboard/RevenueChart";
import TopSellers from "./dashboard/TopSellers";
import LowInventory from "./dashboard/LowInventory";
import TopUsers from "./dashboard/TopUsers";

import { addRoute } from "../../store/actions/route";

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.props.addRoute(props.match);
	}

	render() {
		return (
			<div>
				<h1>Dashboard</h1>
				<div className="chart_collection">
					<RevenueSummary user={this.props.user} />
					<RevenueChart user={this.props.user} />
					<TopSellers user={this.props.user} />
					<TopSellers user={this.props.user} sort={"revenue"} />
					<LowInventory user={this.props.user} />
					<TopUsers user={this.props.user} />
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin
	};
};

export default connect(mapStateToProps, { addRoute })(Dashboard);



// WEBPACK FOOTER //
// ./src/components/admin/AdminDashboard.js